import { Action } from '@ngrx/store';
import { StaticDataState } from './static-data.reducer';

export enum StaticDataActionTypes {
  UPDATE = '[StaticData] Update',
}

export class UpdateStaticData implements Action {
  readonly type = StaticDataActionTypes.UPDATE;

  constructor(public payload: StaticDataState) {}
}

export type All = UpdateStaticData;
